import { Case } from "../../stores/CaseStore/types";
import { Lov } from "../../stores/LovStore/LovStore";
import BaseService from "../BaseService";

export class ConfigService extends BaseService {
  async initApp(currentLanguage: string): Promise<any> {
    const localLanguageCache: Lov = JSON.parse(
      localStorage.getItem(`dictionary-${currentLanguage}`) || "{}"
    );
    const dictionaryUpdatedAt = localLanguageCache?.updatedDate
      ? new Date(localLanguageCache.updatedDate).getTime().toString()
      : "0";

    return this.fetch<any>(`initApp`, {
      cases: "true",
      casesSearch: "true",
      delegations: "true",
      offers: "true",
      givenOffers: "true",
      notifications: "true",
      statistics: "true",
      dictionaryUpdatedAt,
    }).then((result) => ({
      ...result,
      caseSearch: result?.caseSearch?.[0]?.cases.map(
        (caseItem: any): Case => ({ ...caseItem, id: caseItem._id })
      ),
      delegationCases: result?.delegationCases?.[0]?.cases.map(
        (caseItem: any): Case => ({ ...caseItem, id: caseItem._id })
      ),
      dictionary: result?.dictionary?.[0] || null,
      featureFlags: result?.featureFlags?.map((flag: any) => ({
        ...flag,
        id: flag._id,
      })),
    }));
  }

  async fetchFeatureFlags(): Promise<any[]> {
    return this.fetch<any[]>(`flags`);
  }
}
